// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { PatientNameResponse } from './patient-name-response';

// @ts-ignore
import { ProviderResponse } from './provider-response';

// @ts-ignore
import { ReferenceDataResponse } from './reference-data-response';

/** See com.rev360.pms.api.controller.patient.PatientReferralResponse */
/* istanbul ignore next */
@GandalfModel
export class PatientReferralResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	comments!: string | null;

	@GandalfProperty({ designType: ReferenceDataResponse })
	incentiveProgram!: ReferenceDataResponse | null;

	@GandalfProperty({ designType: Date })
	incentiveSentDate!: Date | null;

	@GandalfProperty({ designType: PatientNameResponse })
	patient!: PatientNameResponse | null;

	@GandalfProperty({ designType: Date })
	referralDate!: Date | null;

	@GandalfProperty({ designType: PatientNameResponse })
	referringPatient!: PatientNameResponse | null;

	@GandalfProperty({ designType: ProviderResponse })
	referringProvider!: ProviderResponse | null;

	@GandalfProperty({ designType: ReferenceDataResponse })
	source!: ReferenceDataResponse | null;

	@GandalfConstantDecorator(constants.PatientReferralSourceType)
	@GandalfProperty({ designType: constants.PatientReferralSourceType })
	sourceType!: constants.PatientReferralSourceType | null;

}
